/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckCircleCutIcon16Regular = forwardRef('CheckCircleCutIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.114 2.836a5.498 5.498 0 0 1 3.237-.165.75.75 0 0 0 .369-1.454A6.998 6.998 0 1 0 14.894 9.2a.75.75 0 0 0-1.478-.257 5.497 5.497 0 1 1-7.302-6.106Z" }),
        React.createElement("path", { d: "M14.778 4.05a.75.75 0 0 0-1.06-1.06L8.35 8.354a.5.5 0 0 1-.707 0L5.758 6.47a.75.75 0 1 0-1.06 1.06l1.885 1.886a2 2 0 0 0 2.829 0l5.366-5.366Z" })));
});
